module.exports = __webpack_public_path__ + "img/stadia_controller_opsz24B.9fe3d91b.svg";